import type { Tarjima } from "./i18n";

/**
 * Xodim profilining yorliqlari — tartib UI'dagi tartib bilan BIR XIL.
 *
 * ⚠️ Ro'yxat FILTRLANADI: har yorliq o'z ruxsatini talab qilishi mumkin
 * (`EMPLOYEE_TAB_PERMISSION`). «Umumiy» hech qanday qo'shimcha ruxsat
 * talab qilmaydi, ya'ni ruxsat etilganlar ro'yxati HECH QACHON bo'sh
 * bo'lmaydi — `resolveTab` ning zaxira qiymati shu kafolatga tayanadi.
 */
export const EMPLOYEE_TABS = [
	"umumiy",
	"davomat",
	"smenalar",
	"arizalar",
	"topshiriqlar",
	"lidlar",
	"qurilmalar",
	"hududlar",
	"audit",
] as const;

export type EmployeeTab = (typeof EMPLOYEE_TABS)[number];

/**
 * ⚠️ Qattiq kodlangan `EMPLOYEE_TAB_LABELS` lug'ati o'rniga — P7 spec §8.
 * Matn `employees.json`ning `tabs.*` kalitlaridan.
 */
export function employeeTabLabel(t: Tarjima, tab: EmployeeTab): string {
	return t(`tabs.${tab}`);
}

/**
 * Yorliqning ruxsat darvozasi — `[resource, action]`.
 *
 * ⚠️ Ro'yxatda BO'LMAGAN yorliq qo'shimcha ruxsat talab qilmaydi
 * (profilning o'zini ochish uchun `employees:read` allaqachon kerak).
 *
 * ⚠️ **`audit:read` urug'langan `Rahbar` rolida ATAYLAB yo'q** — audit
 * jurnali BARCHA bo'limlar ustidagi amallarni ko'rsatadi, ya'ni uni
 * bo'lim bilan cheklangan rolga berish doiradan chiqarib yuborardi.
 * Ya'ni rahbar uchun bu yorliq ko'rinmasligi — normal holat.
 */
export const EMPLOYEE_TAB_PERMISSION: Partial<Record<EmployeeTab, [string, string]>> = {
	qurilmalar: ["devices", "read"],
	hududlar: ["zones", "read"],
	audit: ["audit", "read"],
};

/**
 * URL'dagi `?tab=` qiymatini RUXSAT ETILGAN yorliqqa aylantiradi.
 *
 * ⚠️ Noma'lum qiymatda 404 EMAS, birinchi ruxsat etilgan yorliqqa
 * tushadi: eskirgan havola (yorliq nomi o'zgargan yoki olib tashlangan)
 * sahifani buzmasligi kerak.
 *
 * ⚠️⚠️ **`allowed` ni tekshirish MAJBURIY, `EMPLOYEE_TABS` yetarli
 * EMAS.** Yorliqlar ruxsatga qarab filtrlangach, `?tab=audit` bilan
 * kelgan `audit:read` siz foydalanuvchi MAVJUD bo'lmagan yorliqni faol
 * deb ko'rsatardi va `Tabs` BO'SH chiqardi — xato yo'q, sahifa esa
 * ishlamaydi.
 *
 * ⚠️ Kirish `unknown` sifatida qaraladi — `validateSearch` yo'q, ya'ni
 * `?tab=a&tab=b` massiv, `?tab` esa bo'sh qator beradi.
 */
export function resolveTab(raw: string | undefined, allowed: readonly EmployeeTab[]): EmployeeTab {
	const zaxira = allowed[0] ?? EMPLOYEE_TABS[0];

	if (typeof raw !== "string") {
		return zaxira;
	}

	return (allowed as readonly string[]).includes(raw) ? (raw as EmployeeTab) : zaxira;
}
